import { createFileRoute } from '@tanstack/react-router';

import { DuplicateCustomPartOfferPage as PartLibraryDuplicateCustomPartOfferPage } from '@/areas/offers/CustomPartOfferForm/pages/DuplicateCustomPartOfferPage';
import { canEditPartLibraryOffers } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/parts/components/ipn/offers/$offerId/duplicate')({
    staticData: { access: { permissions: canEditPartLibraryOffers }, chrome: 'home' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    return <PartLibraryDuplicateCustomPartOfferPage {...pathParams} />;
}
